import getDatasourceByType from './utils/getDatasourceByType';
import filters from '../filters';

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'Discuss',
            moreConfig: {
                transformItem(originItem) {
                    const item = originItem;
                    item.type = 1;
                    return item;
                }
            }
        })
            .then(list => {
                const filterList = filters.filterTroopList(list, selfConfig);
                resolve(filterList);
            })
            .catch(err => {
                reject(err);
            });
    });
}
